"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconPasswordSee = void 0;
var React = __importStar(require("react"));
var IconPasswordSee = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M12,17 C17.738,17 22,13.172 22,12 C22,10.828 17.738,7 12,7 C6.262,7 2,10.828 2,12 C2,13.225 6.5,17 12,17 Z M12,6 C18.02,6 23,9.973 23,12 C23,14.027 18.02,18 12,18 C6.092,18 1,13.976 1,12 C1,9.973 5.98,6 12,6 Z M12,15 C13.654,15 15,13.654 15,12 C15,10.346 13.654,9 12,9 C10.346,9 9,10.346 9,12 C9,13.654 10.346,15 12,15 Z M12,8 C14.206,8 16,9.794 16,12 C16,14.206 14.206,16 12,16 C9.794,16 8,14.206 8,12 C8,9.794 9.794,8 12,8 Z M12.25,10 C12.351,10 12.442,10.061 12.481,10.154 C12.52,10.248 12.498,10.355 12.427,10.427 L10.427,12.427 C10.379,12.475 10.315,12.5 10.25,12.5 C10.218,12.5 10.185,12.494 10.154,12.481 C10.061,12.442 10,12.352 10,12.25 C10,11.01 11.009,10 12.25,10 Z" }))); };
exports.IconPasswordSee = IconPasswordSee;
exports.IconPasswordSee.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconPasswordSee;
